import {createSvgIcon} from '../create-svg-icon';

export const DoubleArrowIcon = createSvgIcon(
  [<path d="M15.5 5H11l5 7-5 7h4.5l5-7z" key="0" />,<path d="M8.5 5H4l5 7-5 7h4.5l5-7z" key="1" />,]
, 'DoubleArrowOutlined');
